/**
 * Component: A11y Decorative Image Helper
 * 
 */
'use strict';

export class A11yVideoHelper {

  constructor() {}

  init() {
    this.init_a11y_video_helper();
  }

  init_a11y_video_helper = () => {
    const videos = document.querySelectorAll('video'),
          motionQuery = matchMedia('(prefers-reduced-motion)');

    // If 'prefers-reduced-motion' is set to true, pause all autoplay videos
    const reducedMotionCheck = () => {
      if ( motionQuery.matches === true ) {
        videos.forEach((video) => {
          if ( video.getAttribute('autoplay') == 'true' ) {
            video.pause();
          }
        });
      }
      else {
        videos.forEach((video) => {
          if ( video.getAttribute('autoplay') == 'true' ) {
            video.play();
          }
        });
      }
    }
    reducedMotionCheck(); 
    motionQuery.addListener(reducedMotionCheck); 

    videos.forEach((video) => {
      const videoControls = video.getAttribute('controls');
      
      // If video controls are not available, add the video to the tab order (for play/pause control)
      if ( videoControls === null ) {
        video.setAttribute('tabindex', 0);

        video.addEventListener( 'keydown', (e) => {
          const _this = e.target;
          if ( e.key == " " || e.code == "Space" || e.keyCode == 32 ) {
            e.preventDefault();

            if ( !_this.paused ) {
              _this.pause();
            } else {
              _this.play();
            }
          }
        });

      }
    });

  }
}
